import { pathnameHasLanguage } from '../pathnameHasLanguage/pathnameHasLanguage';

/** Returns the language from the given url or undefined if the url does not contain a language */
export const getLanguageFromUrl = (url: string) =>
  pathnameHasLanguage(url) ? url.substring(1, 3) : undefined;
